import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import {
  Button, LoadingIndicator, TextField, ErrorMessage, AuthWrapper,
} from '../components';

const styles = theme => ({
  buttonStyle: {
    width: '100%',
  },
  formGroupStyle: {
    width: '100%',
    textAlign: 'center',
    marginTop: 10,
  },
  inputStyle: {
    width: '100%',
  },
  forgotPassword: {
    marginTop: 10,
    color: theme.palette.primary.main,
  },
  success: {
    fontWeight: 'bold',
  },
});


class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      validationErrorMessage: '',
    };
  }

  keyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.resetPassword();
      return false;
    }
    return true;
  }

  resetPassword = () => {
    const { resetPassword, validateEmail } = this.props;
    const { email } = this.state;

    if (validateEmail(email)) {
      resetPassword({ email });
      return;
    }
    this.setState({ validationErrorMessage: 'Bitte geben Sie eine valide E-Mail ein!' });
  }

  renderForgotPasswordButton = () => {
    const { classes, isLoading } = this.props;

    if (isLoading) {
      return <LoadingIndicator />;
    }
    return (
      <Button
        onClick={this.resetPassword}
        label="Passwort zurücksetzen"
        color="primary"
        variant="contained"
        className={classes.buttonStyle}
      />
    );
  };

  render() {
    const {
      classes, login, logo, errorMessage, success,
    } = this.props;
    const { email, validationErrorMessage } = this.state;

    return (
      <AuthWrapper onKeyPress={this.keyPress} logo={logo}>
        {success ? <div className={classes.success}>Bitte überprüfen Sie Ihren Posteingang für weitere Anweisungen.</div>
          : (
            <form noValidate>
              <ErrorMessage errorMessage={errorMessage} />
              <div
                className={classes.formGroupStyle}
                style={{
                  marginTop: 15,
                }}
              >
                <TextField
                  autoFocus
                  required
                  fullWidth
                  className={classes.inputStyle}
                  placeholder="E-Mail"
                  value={email}
                  onChange={e => this.setState({ email: e.target.value, validationErrorMessage: null })}
                  errortext={validationErrorMessage}
                />
              </div>
              <div
                className={classes.formGroupStyle}
                style={{
                  marginTop: 40,
                }}
              >
                {this.renderForgotPasswordButton()}
              </div>
            </form>
          )
        }
        {login}
      </AuthWrapper>
    );
  }
}


ForgotPassword.propTypes = {
  classes: PropTypes.object.isRequired,
  errorMessage: PropTypes.string,
  isLoading: PropTypes.bool,
  login: PropTypes.element,
  logo: PropTypes.string.isRequired,
  success: PropTypes.bool.isRequired,
  resetPassword: PropTypes.func.isRequired,
  validateEmail: PropTypes.func.isRequired,
};

ForgotPassword.defaultProps = {
  errorMessage: null,
  isLoading: false,
  login: null,
};

export default withStyles(styles)(ForgotPassword);
